export { default as AlignLeft } from './AlignLeft'
export { default as BezierCurve03 } from './BezierCurve03'
export { default as Bold01 } from './Bold01'
export { default as Colors } from './Colors'
export { default as Cursor02C } from './Cursor02C'
export { default as Dotpoints01 } from './Dotpoints01'
export { default as Hand02 } from './Hand02'
export { default as ImageIndentLeft } from './ImageIndentLeft'
export { default as Italic01 } from './Italic01'
export { default as LeftIndent02 } from './LeftIndent02'
export { default as LetterSpacing01 } from './LetterSpacing01'
export { default as Strikethrough01 } from './Strikethrough01'
export { default as TitleCase } from './TitleCase'
export { default as TypeSquare } from './TypeSquare'
export { default as ZoomIn } from './ZoomIn'
export { default as ZoomOut } from './ZoomOut'
